Vue.component('reset-password', {
    props: ['password-key'],

    data () {
        return {
            resetPasswordForm: $.extend(true, new Form({
                data: {
                    email: '',
                    password: '',
                    password_confirmation: ''
                }
            }), {})
        };
    },

    methods: {
        submit () {
            Http.post('/api/authpassword/reset', this.resetPasswordForm, {
                params: {
                    key: this.passwordKey
                }
            }).then((response) => {
                this.resetPasswordForm.resetForm();
            });
        },

        handlePasswordChange (field, value) {
            this.resetPasswordForm.data[field] = value;
        }
    }
});